import React, { Fragment, useEffect, useMemo, useState } from 'react';
import lodash from 'lodash';
import { PageDescription, PageTitle, } from 'components/common/Study/PageComponents';
import { connect } from 'react-redux';
import { Button, BUTTON } from 'components/common/Button/Button';
import DismissibleModal from 'components/common/DismissibleModal/DismissibleModal';
import classnames from 'classnames';
import { useImmer } from 'use-immer';
import moment from 'moment';
import ActionModal from 'components/common/ActionModal/ActionModal';
import { LoadingStatus } from 'components/common/LoadingStatus/LoadingStatus';
import { TeamMembers } from 'components/common/Study/ListItemCards/StudyTeamMemberCard';
import StudyTeamMemberForm, { StudyTeamMemberTypePanel, DetailedText, STUDY_USER_TYPE, STUDY_TEAM_CAPITAL }
    from 'components/common/Study/StudyTeamMemberForm';
import {
    createTeamMember,
    editStudyTeamMember,
    getStudyTeam,
    getStudyDescriptors,
    getStudyRoles,
    getTeamMembersByInstitution,
    removeStudyTeamMember,
    unloadStudySettingsTeam,
} from 'pages/studyOverview/actions/studySettings';
import { modifyStudyTeamMember } from 'pages/studyOverview/actions/studySettingsStudyTeam';
import {
    getSortedStudyTeamMembers,
    getTeamMemberSelection,
    getUsersWithSameGroups,
} from './utils/selectors';
import { formattedUserOptions } from './utils/helperFunctions';
import { UserCanManageStudyTeamMemberOld } from 'common/permissions/components/actionButton';
import { loadStudyTasksV2 } from 'pages/delegationOfAuthority/v2/actions/studyTasksV2';
import { loadStudyDelegationsV2 } from 'pages/delegationOfAuthority/v2/actions/studyDelegationsV2';
import { Conditional } from 'common/components/layout';
import { push } from 'react-router-redux';
import { doaFeatureAccess } from 'common/features/predicates';
import { isPITenureOverlappingWithDelegation } from 'pages/delegationOfAuthority/util/predicates';
import StudyModal from './StudyModal/StudyModal';
import {
    updateStudyDelegationV2,
} from 'pages/delegationOfAuthority/v2/actions/studyDelegationsV2';
import {
    stackASuccessMessage
} from 'pages/delegationOfAuthority/v2/actions/studyDelegationsV2';
import { manageAdminsPredicate, manageStudyTeamMemberPredicateOld } from 'common/permissions/studyPredicates';
import DelegationStatement from 'pages/delegationOfAuthority/v2/components/DelegationStatement/DelegationStatement';
import { Typography } from '@material-ui/core';
import { convertToISOString } from 'common/util/dateTime';
import { getActivePI } from '../../../../delegationOfAuthority/selectors/index.js';

import styles from './StudySettingsTeamV2.scss';

const parseDateFormat = (date) => {
    if (lodash.isNil(date)) {
        return null;
    }

    return moment.utc(date);
};

const getDistinctUsers = (usersWithSameGroup, selectedStudyTeams) => {
    const allNonAddedUsers = lodash.differenceBy(usersWithSameGroup, selectedStudyTeams, 'userId');
    return formattedUserOptions(allNonAddedUsers);
};

export const studyMemberTypeFlow = (form, studyMemberType) => {
    let formReadyCondition = form.userId !== '';

    switch (studyMemberType) {
        case STUDY_USER_TYPE.VIEWER:
        case STUDY_USER_TYPE.ADMIN:
            if (form.studyRoleId !== '') {
                formReadyCondition = formReadyCondition && form.nameOfResearcher !== undefined;
            }
            break;
        case STUDY_USER_TYPE.TEAM:
            formReadyCondition = formReadyCondition && form.nameOfResearcher !== undefined && form.studyRoleId !== '';
            break;
    }

    return formReadyCondition;
};

export function StudyTeamV2(props) {
    const [isAddPanelShowing, showAddPanel] = useState(false);
    const [isEditPanelShowing, showEditPanel] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const [selectedUser, setSelectedUser] = useState({});

    const [showModalAudit, setShowModalAudit] = useState(false);
    const [auditNote, setAuditNote] = useState('');

    useEffect(() => {
        props.getStudyTeam(props.study.id, props.study.institutionId);
        props.getStudyRoles(props.study.institutionId);
        props.getTeamMembersByInstitution(props.study.institutionId);
        props.getStudyDescriptors(props.study.institutionId, props.study.studyTypeId);
        props.loadStudyTasksV2(props.study.binderId, props.study.id);
        props.loadStudyDelegationsV2(props.study.binderId, props.study.id);
    }, []);

    useEffect(() => {
        if (isAddPanelShowing) {
            showEditPanel(false);
        }
    }, [isAddPanelShowing]);

    useEffect(() => {
        if (isEditPanelShowing) {
            showAddPanel(false);
        }
    }, [isEditPanelShowing]);

    const users = lodash.get(props, 'users', []);
    const usersWithSameGroup = lodash.get(props, 'usersWithSameGroup', []);
    const studyRoles = lodash.get(props, 'studyRoles', []);
    const staffDescriptor = lodash.get(props, 'staffDescriptor.dataSources', []);
    const usersOptions = formattedUserOptions(users);
    const selectedStudyTeams = lodash.get(props, 'selectedStudyTeams', []);
    const addUserOptions = useMemo(() => getDistinctUsers(usersWithSameGroup, selectedStudyTeams), [usersWithSameGroup.length, selectedStudyTeams.length]);
    const studyRolesOptions = studyRoles.map(role => (
        { value: role.id, label: role.name })
    );
    const staffDescriptorOptions = staffDescriptor.map(staffDescriptor => (
        { value: staffDescriptor.value, label: staffDescriptor.text })
    );
    const SecuredAddTeamMemberButton = UserCanManageStudyTeamMemberOld(AddTeamMemberButton);
    const SecuredSetupDelegationTasksButton = UserCanManageStudyTeamMemberOld(SetupDelegationTasksButton);

    const goToSetupDelegationSetupPage = (studyId) => {
        props.push(`/study/${studyId}/delegation?showSetupTasks=true`);
    };

    props.isProcessingStudySettings && <LoadingStatus itemName={'study settings'} loading={true} filterQuery={false} />;
    const delegatedUserMissingTasks = props.isDoaEnabled && props.doaStudyTasks.length === 0 && props.selectedStudyTeams.length !== 0;
    return (
        <div className={
            classnames(
                styles.studyTeamContainer,
                { [styles.panelOpen]: isAddPanelShowing || isEditPanelShowing }
            )
        } data-cy="StudySettingsTeamV2">
            <PageTitle>Study Team</PageTitle>
            <PageDescription>Add study admin, team members and study viewers to this study.</PageDescription>
            <section className={styles.actionSection} data-cy="StudySettingsTeamV2-section">
                <SecuredAddTeamMemberButton
                    onClick={() => showAddPanel(true)}
                />
                <Conditional condition={delegatedUserMissingTasks}>
                    <SecuredSetupDelegationTasksButton
                        className={styles.actionSectionRight}
                        onClick={() => goToSetupDelegationSetupPage(props.study.id)}
                    />
                </Conditional>
            </section>

            <div data-cy="StudySettingsTeamV2-div">
                <TeamMembers
                    setSelectedUser={setSelectedUser}
                    setShowModal={setShowModal}
                    setShowPanel={showEditPanel}
                    studyTeam={props.selectedStudyTeams}
                    doaStudyDelegations={props.doaStudyDelegations}
                    isDoaEnabled={props.isDoaEnabled}
                    canManageStudyUsers={props.canManageStudyUsers}
                    canManageStudyAdmins={props.canManageStudyAdmins}
                    doaStudyTasks={props.doaStudyTasks}
                />
            </div>
            <AddTeamMemberPanel
                className={styles.addStudyTeamPanel}
                dismiss={isAddPanelShowing}
                selectedUser={selectedUser}
                usersOptions={addUserOptions}
                studyRolesOptions={studyRolesOptions}
                staffDescriptorOptions={staffDescriptorOptions}
                canManageStudyAdmins={props.canManageStudyAdmins}
                onDismiss={() => {
                    showAddPanel(false);
                }}
                onAdd={(user, type) => {
                    return props.createTeamMember(user, type);
                }}
            />
            {isEditPanelShowing &&
                <EditTeamMemberPanel
                    className={styles.editStudyTeamPanel}
                    dismiss={isEditPanelShowing}
                    selectedUser={selectedUser}
                    usersOptions={usersOptions}
                    studyRolesOptions={studyRolesOptions}
                    staffDescriptorOptions={staffDescriptorOptions}
                    onDismiss={() => {
                        showEditPanel(false);
                    }}
                    onModify={(teamMember, delegation) =>
                        props.modifyStudyTeamMember(teamMember, delegation)
                    }
                    activePI={props.activePI}
                    study={props.study}
                    binderId={props.binderId}
                    doaStudyDelegations={props.doaStudyDelegations}
                    doaMode={props.doaMode}
                    institutionTimezone={props.institutionTimezone}
                    doaStudyTasks={props.doaStudyTasks}
                />
            }
            <RemoveStudyTeamModal
                setShowModal={setShowModal}
                setShowModalAudit={setShowModalAudit}
                showModal={showModal}
                selectedUser={selectedUser}
                removeUser={props.removeStudyTeamMember}
                userType={selectedUser.studyUserType}
                {...props}
            />
            <AuditExplanationStudyModal
                showModalAudit={showModalAudit}
                setShowModalAudit={setShowModalAudit}
                setAuditNote={setAuditNote}
                auditNote={auditNote}
                selectedUser={selectedUser}
                removeUser={props.removeStudyTeamMember}
                {...props}
            />
        </div>
    );
}

export const AddTeamMemberButton = (props) => (
    <div data-cy="StudySettingsTeamV2-btns">
        <Button
            className={props.className}
            bgcolor={BUTTON.BGCOLOR.BLUE}
            color={BUTTON.COLOR.WHITE}
            onClick={props.onClick}
            data-cy="StudySettingsTeamV2-Add"
        >
            Add Member
        </Button>
    </div>
);

export const SetupDelegationTasksButton = (props) => (
    <div data-cy="StudySettingsTeamV2-btn">
        <Button
            className={props.className}
            outline={BUTTON.OUTCOLOR.LIGHTGREY}
            bgcolor={BUTTON.BGCOLOR.CLEAR}
            color={BUTTON.COLOR.BLACK}
            onClick={props.onClick}
            data-cy="StudySettingsTeamV2-Setup"
        >
            Setup Delegation Tasks
        </Button>
    </div>
);

export const AddTeamMemberPanel = (props) => {
    const [potentialMatches, setPotentialMatches] = useState([]);
    const [studyMemberType, setStudyMemberType] = useState('');
    const [form, setForm] = useImmer({
        userId: '',
        sub: '',
        displayName: '',
        studyRoleId: '',
        studyRole: {
            id: '',
            name: '',
        },
        nameOfResearcher: undefined,
    });

    const isFormReady = () => {
        return studyMemberTypeFlow(form, studyMemberType);
    };

    function dismissForm() {
        setForm(draft => {
            draft.userId = '';
            draft.sub = '';
            draft.studyRoleId = '';
            draft.nameOfResearcher = undefined;
        });
        setPotentialMatches([]);
        setStudyMemberType('');
        props.onDismiss();
    }
    return (
        <DismissibleModal
            title="Add Member"
            open={props.dismiss}
            onDismiss={() => dismissForm()}
            onSubmit={() => {
                props.onAdd({
                    sub: form.sub,
                    userId: form.userId,
                    studyRoleId: form.studyRoleId,
                    studyRoleName: form.studyRole.name,
                    displayName: form.displayName,
                    nameOfResearcher: form.nameOfResearcher
                }, studyMemberType);
                dismissForm();
            }}
            submitActionDisabled={!isFormReady()}
            submitTitle="Add Member"
            data-cy="StudySettingsTeamV2-dismissForm"
        >
            {!props.editMode &&
                <StudyTeamMemberTypePanel
                    label={'Select a Member Type'}
                    studyMemberType={studyMemberType}
                    setType={setStudyMemberType}
                    displayStudyAdminOption={props.canManageStudyAdmins}
                />
            }
            <StudyTeamMemberForm
                editStatus={false}
                form={form}
                setForm={setForm}
                potentialMatches={potentialMatches}
                setPotentialMatches={setPotentialMatches}
                teamMembersOptions={props.usersOptions}
                studyRolesOptions={props.studyRolesOptions}
                staffDescriptorOptions={props.staffDescriptorOptions}
                studyMemberType={studyMemberType}
            />

            {studyMemberType === '' &&
                <Fragment data-cy="StudySettingsTeamV2-Fragment">
                    <Conditional condition={props.canManageStudyAdmins}>
                        <DetailedText
                            title={'Study Admin'}
                            description={'An internal user who has the ability to manage all aspects of the study including Study Details, Study Team, and Expectations. They are a key administrator of the Study.'}
                        />
                    </Conditional>
                    <DetailedText
                        title={'Study Team Member'}
                        description={'A team member is an internal user who is assigned to a role to carry out delegated study tasks.'}
                    />
                    <DetailedText
                        title={'Study Viewer'}
                        description={'An internal user at this institution with access to the study, but is not on the delegation log.'}
                    />
                </Fragment>
            }
        </DismissibleModal>
    );
};

export const EditTeamMemberPanel = (props) => {
    const [form, setForm] = useImmer({
        userId: '',
        sub: '',
        displayName: '',
        studyRoleId: '',
        studyRole: {
            id: '',
            name: '',
        },
        nameOfResearcher: undefined,
        hasAdminRole: false,
    });

    const PI_ROLE = 'Principal Investigator';
    const [isSubmit, setSubmit] = useState(false);
    const [auditNote, setAuditNote] = useState('');
    const [isRequesting, setIsRequesting] = useState(false);

    useEffect(() => {
        setForm(draft => {
            draft.userId = props.selectedUser.userId;
            draft.sub = props.selectedUser.sub;
            draft.displayName = props.selectedUser.displayName;
            draft.studyRoleId = props.selectedUser.studyRoleId;
            draft.studyRole.name = props.selectedUser.studyRole ? props.selectedUser.studyRole.name : '';
            draft.studyRole.id = props.selectedUser.studyRole ? props.selectedUser.studyRole.id : '';
            draft.nameOfResearcher = props.selectedUser.nameOfResearcher;
            draft.hasAdminRole = props.selectedUser.hasAdminRole;
        });
    }, []);

    const isFormReady = () => {
        if (isSubmit && hasCompletedSignature() && auditNote.length === 0) {
            return false;
        }

        const studyUserType = lodash.get(props, 'selectedUser.studyUserType');
        return studyMemberTypeFlow(form, studyUserType);
    };

    const hasAddedStudyRole = form.studyRoleId !== '' && props.selectedUser.studyRoleId === null;

    const hasChangeStudyRole = !hasAddedStudyRole &&
        form.studyRoleId !== '' && form.studyRoleId !== props.selectedUser.studyRoleId;

    const hasCompletedSignature = () => {
        if (!props.selectedUser) {
            return;
        }

        const selectedUserDelegation = props.doaStudyDelegations.find((d) => {
            return d.user.id === props.selectedUser.userId;
        });

        if (lodash.isEmpty(selectedUserDelegation)) {
            return true;
        }

        if (!Array.isArray(selectedUserDelegation.signatures)) {
            return false;
        }

        const completedSignature = selectedUserDelegation.signatures.some((s) => {
            return s.signatureStatus === 'COMPLETED';
        });

        return completedSignature;
    };

    function dismissForm() {
        setForm(draft => {
            draft.userId = '';
            draft.sub = '';
            draft.studyRoleId = '';
            draft.nameOfResearcher = undefined;
            draft.hasAdminRole = false;
        });
        setSubmit(false);
        setAuditNote('');
        setIsRequesting(false);
        props.onDismiss();
    }

    const collectPISignatures = (dataUser) => {
        if (form.studyRole.name === PI_ROLE) {
            return [
                {
                    user: {
                        name: dataUser.user.displayName,
                        id: dataUser.user.id,
                    },
                    signatureType: 'PI_START',
                    delegationId: dataUser.id,
                    studyId: props.study.id
                },
            ];
        }
        return lodash
            .chain(props.doaStudyDelegations)
            .filter(
                ({ rolesManagement, startDate, endDate, user }) =>
                    lodash.get(rolesManagement, 'name', '') === PI_ROLE &&
                    user.id !== dataUser.user.id &&
                    isPITenureOverlappingWithDelegation(
                        [startDate, endDate],
                        [dataUser.startDate, dataUser.endDate]
                    )
            )
            .map(({ user }) => ({
                user: {
                    name: user.displayName,
                    id: user.id,
                },
                signatureType: 'PI_START',
                delegationId: dataUser.id
            }))
            .value();
    };

    const collectStaffSignatures = (dataUser) => {
        if (props.doaMode === 'CENTRAL' || form.studyRole.name === PI_ROLE) {
            return [];
        }

        return [
            {
                user: {
                    name: dataUser.user.displayName,
                    id: dataUser.user.id,
                },
                signatureType: 'STAFF_START',
                delegationId: dataUser.id,
                studyId: props.study.id
            },
        ];
    };

    const collectExistingDelegations = (dataUser) => {
        if (form.studyRole.name !== PI_ROLE) return [];

        const filterStaffNotFullFields = lodash.filter(
            props.doaStudyDelegations,
            ({ rolesManagement, startDate, user, taskIds }) =>
                !(
                    lodash.isEmpty(rolesManagement) ||
                    lodash.isEmpty(taskIds) ||
                    lodash.isEmpty(user) ||
                    lodash.isNil(startDate)
                )
        );

        const staffDelegationsOverlappingWithNewPITenure = lodash.filter(
            filterStaffNotFullFields,
            ({ rolesManagement, startDate, user, endDate }) =>
                rolesManagement &&
                rolesManagement.name !== PI_ROLE &&
                user.id !== dataUser.user.id &&
                isPITenureOverlappingWithDelegation(
                    [startDate, endDate],
                    [dataUser.startDate, dataUser.endDate]
                )
        );

        const result = staffDelegationsOverlappingWithNewPITenure.map(({ user, id }) => ({
            user: {
                name: dataUser.user.displayName,
                id: dataUser.user.id,
            },
            signatureType: 'PI_START',
            delegationId: id,
        }));
        return result;
    };

    const handleModifyStudyTeamMember = (delegation = {}, signatures = []) => {
        props.onModify({
            id: props.selectedUser.id,
            studyUserType: props.selectedUser.studyUserType,
            studyRoleId: form.studyRoleId,
            userId: form.userId,
            hasAdminRole: form.hasAdminRole,
            nameOfResearcher: form.nameOfResearcher,
            displayName: form.displayName,
        }, {
            delegation,
            binderId: delegation && delegation.binderId,
            defaultSignatureExpectations: signatures,
            signatureExpectations: signatures,
            studyRoleId: form.studyRoleId,
            studyRoleName: form.studyRole && form.studyRole.name
        });

        dismissForm();
    };

    const handleOnSubmit = () => {
        const { selectedUser, activePI } = props;
        const userID = selectedUser.userId;
        const sortedDelegations = lodash.orderBy(props.doaStudyDelegations, (doa) => moment(doa.createdAt), ['desc']);

        let dataUser = sortedDelegations.find((doa) => (doa.user.id === userID) && (doa.rolesManagement && (doa.rolesManagement.id === selectedUser.studyRoleId)));
        const selectedUserHasDelegations = dataUser ? true : false;
        const nameOfResearcherChanged = selectedUser.nameOfResearcher !== lodash.get(form, 'nameOfResearcher', undefined);

        if (!isSubmit && !hasChangeStudyRole && selectedUserHasDelegations) {
            handleModifyStudyTeamMember();
            return;
        }

        if (!isSubmit && hasChangeStudyRole) {
            setSubmit(true);
            return;
        }

        if (!hasChangeStudyRole && selectedUserHasDelegations) {
            handleModifyStudyTeamMember();
            return;
        }

        const studyRoleSet = hasAddedStudyRole || hasChangeStudyRole;

        if (!studyRoleSet && nameOfResearcherChanged) {
            handleModifyStudyTeamMember();
            return;
        }

        setIsRequesting(true);

        const startDate = parseDateFormat(moment().format('LL'));

        const isStillStaff =
            lodash.get(dataUser, 'rolesManagement.name', '') !== PI_ROLE &&
            lodash.get(form, 'studyRole.name', '') !== PI_ROLE;

        const isChangePIToStaff =
            lodash.get(dataUser, 'rolesManagement.name', '') === PI_ROLE &&
            lodash.get(form, 'studyRole.name', '') !== PI_ROLE;


        const delegation = lodash.cloneDeep({
            binderId: props.binderId,
            id: (selectedUserHasDelegations ? dataUser.id : null),
            studyId: props.study.id,
            user: {
                id: selectedUser.user.id,
                name: selectedUser.user.displayName,
            },
            tasks: (selectedUserHasDelegations ? props.doaStudyTasks.filter((task) => dataUser.taskIds.includes(task.id)) : []),
            startDate: getStartDateOrNullIfActivePI(selectedUser, startDate),  //convertToISOString(startDate),
            endDate: (selectedUserHasDelegations ? convertToISOString(parseDateFormat(dataUser.endDate)) : null),
            notes: auditNote,
            isRevokedPIRole: !isChangePIToStaff,
            isStillStaff,
            auditOrigin: 'Study Settings',
            auditActivity: 'Updating this Study Team Member’s role in Study Settings updates this user’s start date.'
        });


        const studyRoleId = lodash.get(form.studyRole, 'id', null);

        if (studyRoleId) {
            delegation.roleManagementId = studyRoleId;
        }

        function getStartDateOrNullIfActivePI(selectedUser, startDate) {
            if (!activePI) {
                return convertToISOString(startDate);
            }

            const userIsActivePI = selectedUser.user.id === activePI.user.id;

            if (userIsActivePI || activePI.rolesManagement.id != lodash.get(form.studyRole, 'id', null)) {
                return convertToISOString(startDate);
            }

            return null;
        }
        if (selectedUserHasDelegations) {
            dataUser = { ...dataUser, startDate: delegation.startDate };
        }
        const isFullFields = dataUser && (
            !lodash.isNil(dataUser.startDate) &&
            !lodash.isEmpty(dataUser.user) &&
            !lodash.isEmpty(dataUser.taskIds) &&
            !lodash.isNil(form.studyRoleId)
        );
        const existSignatureSuggested = dataUser ? collectExistingDelegations(dataUser) : [];

        if (isFullFields) {
            const piSignatureSuggested = collectPISignatures(dataUser);
            const staffSignatureSuggested = collectStaffSignatures(dataUser);
            const allSignatureSuggested = [...piSignatureSuggested, ...staffSignatureSuggested, ...existSignatureSuggested];

            handleModifyStudyTeamMember(delegation, allSignatureSuggested);
        } else {
            handleModifyStudyTeamMember(delegation, existSignatureSuggested);
        }
    };

    return (
        <DismissibleModal
            title={(hasChangeStudyRole && isSubmit) ? 'Audit Explanation for User’s Delegation' : 'Edit Member'}
            open={props.dismiss}
            onDismiss={() => dismissForm()}
            onSubmit={handleOnSubmit}
            submitActionDisabled={!isFormReady() || isRequesting}
            submitTitle="Confirm"
            data-cy="StudySettingsTeamV2-DismissibleModal"
        >
            <Conditional condition={!isSubmit}>
                <StudyTeamMemberForm
                    editStatus={true}
                    form={form}
                    setForm={setForm}
                    studyMemberType={props.selectedUser.studyUserType}
                    teamMembersOptions={props.usersOptions}
                    studyRolesOptions={props.studyRolesOptions}
                    staffDescriptorOptions={props.staffDescriptorOptions}
                />
            </Conditional>

            <Conditional condition={isSubmit && hasChangeStudyRole}>
                <div className={styles.auditNote} data-cy="StudySettingsTeamV2-auditNote">
                    <Conditional condition={!hasCompletedSignature()}>
                        <DelegationStatement type="warning" size="small">
                            <Typography variant="body2">
                                This Study User has a delegation that has NOT been signed. Modifying data
                                before signature does NOT require a note for the audit log. Entering notes
                                for the audit log is optional.
                            </Typography>
                        </DelegationStatement>
                    </Conditional>
                    <Conditional condition={hasCompletedSignature()}>
                        <DelegationStatement type="warning" size="small">
                            <Typography variant="body2">
                                This Study User has a delegation that has been signed. Modifying
                                data after signature requires a note for the audit log.
                            </Typography>
                        </DelegationStatement>
                    </Conditional>

                    <h5 className={styles.auditNote__title} data-cy="StudySettingsTeamV2-h5">Audit Notes
                        <Conditional condition={hasCompletedSignature()}>
                            <span className={styles.AuditNote__required}>*Required</span>
                        </Conditional>
                    </h5>

                    <textarea
                        className={styles.auditNote__area}
                        placeholder={'Add notes to the audit record of this delegation...'}
                        value={auditNote}
                        rows={4}
                        onChange={(e) => {
                            setAuditNote(e.target.value);
                        }}
                        data-cy="StudySettingsTeamV2-textarea"
                    />
                </div>
            </Conditional>
        </DismissibleModal>
    );
};

export const ActionRow = (props) => (
    <div className={styles.actionRow} data-cy="StudySettingsTeamV2-ActionRow">
        <Button
            bgcolor={BUTTON.BGCOLOR.CLEAR}
            color={BUTTON.COLOR.BLACK}
            type={BUTTON.SIZE.SECONDARY}
            onClick={props.onCancel}
            data-cy="StudySettingsTeamV2-Cancel"
        >
            Cancel
        </Button>
        <Button
            bgcolor={BUTTON.BGCOLOR.ORANGE}
            color={BUTTON.COLOR.WHITE}
            onClick={props.onPrimaryAction}
            disabled={props.primaryActionDisabled}
            data-cy="StudySettingsTeamV2-actionButtonLabel"
        >
            {props.actionButtonLabel}
        </Button>
    </div>
);
export const AuditExplanationStudyModal = ({
    showModalAudit,
    setShowModalAudit,
    setAuditNote,
    selectedUser,
    removeUser,
    auditNote,
    study,
    ...props
}) => {
    const PI_ROLE = 'Principal Investigator';
    const [isRequiredNote, setRequiredNote] = useState(false);

    useEffect(() => {
        if (showModalAudit && selectedUser) {
            const userID = selectedUser.userId;
            const sortedDelegations = lodash.orderBy(props.doaStudyDelegations, (doa) => moment(doa.createdAt), ['desc']);
            const dataUser = sortedDelegations.find((doa) => (doa.user.id === userID) && (doa.rolesManagement && (doa.rolesManagement.id === selectedUser.studyRoleId)));
            const signatures = lodash.get(dataUser, 'signatures', []);
            const completedSignatures = signatures.filter((item) => item.signatureStatus === 'COMPLETED');
            setRequiredNote(!!completedSignatures.length);
        }
    }, [auditNote, showModalAudit, selectedUser]);

    const collectPISignatures = (dataUser) => {
        if (dataUser.rolesManagement.name === PI_ROLE) {
            return [
                {
                    user: {
                        name: dataUser.user.displayName,
                        id: dataUser.user.id,
                    },
                    signatureType: 'PI_START',
                    delegationId: dataUser.id,
                    studyId: study.id
                },
            ];
        }

        return lodash
            .chain(props.doaStudyDelegations)
            .filter(
                ({ rolesManagement, startDate, endDate, user }) =>
                    lodash.get(rolesManagement, 'name', '') === PI_ROLE &&
                    user.id !== dataUser.user.id &&
                    isPITenureOverlappingWithDelegation(
                        [startDate, endDate],
                        [dataUser.startDate, dataUser.endDate]
                    )
            )
            .map(({ user }) => ({
                user: {
                    name: user.displayName,
                    id: user.id,
                },
                signatureType: 'PI_START',
                delegationId: dataUser.id
            }))
            .value();
    };

    const collectStaffSignatures = (dataUser) => {
        if (props.doaMode === 'CENTRAL' || dataUser.rolesManagement.name === PI_ROLE) {
            return [];
        }

        return [
            {
                user: {
                    name: dataUser.user.displayName,
                    id: dataUser.user.id,
                },
                signatureType: 'STAFF_START',
                delegationId: dataUser.id,
                studyId: study.id
            },
        ];
    };

    const handleOnSave = () => {
        const userID = selectedUser.userId;
        const sortedDelegations = lodash.orderBy(props.doaStudyDelegations, (doa) => moment(doa.createdAt), ['desc']);
        const dataUser = sortedDelegations.find((doa) => (doa.user.id === userID) && (doa.rolesManagement && (doa.rolesManagement.id === selectedUser.studyRoleId)));
        const endDate = parseDateFormat(moment().format('LL'));

        let delegation = lodash.cloneDeep({
            binderId: props.binderId,
            id: dataUser.id,
            studyId: study.id,
            user: {
                id: dataUser.user.id,
                name: dataUser.user.displayName,
            },
            tasks: props.doaStudyTasks.filter((task) => dataUser.taskIds.includes(task.id)),
            startDate: convertToISOString(parseDateFormat(dataUser.startDate)),
            endDate: convertToISOString(endDate),
            notes: auditNote,
            isRevokedPIRole: false,
            isStillStaff: false,
            auditOrigin: 'Study Settings',
            auditActivity: 'Removing this Study Team Member in Study Settings updates this user’s end date.'
        });

        if (new Date(dataUser.startDate) >= new Date()) {
            delegation.startDate = convertToISOString(parseDateFormat(moment().format('LL')));
        }

        const isFullFields =
            !lodash.isNil(dataUser.startDate) &&
            !lodash.isEmpty(dataUser.user) &&
            !lodash.isEmpty(dataUser.taskIds) &&
            !lodash.isNil(dataUser.rolesManagement);

        if (isFullFields) {
            const piSignatureSuggested = collectPISignatures(dataUser);
            const staffSignatureSuggested = collectStaffSignatures(dataUser);

            const allSignatureSuggested = [...piSignatureSuggested, ...staffSignatureSuggested];

            // This case default signatures & requested signatures the same
            props.updateStudyDelegationV2(
                delegation.binderId,
                delegation,
                allSignatureSuggested,
                allSignatureSuggested,
                () => {
                    setShowModalAudit(false);
                    setAuditNote('');
                    props.stackASuccessMessage(
                        'This End Date on this user\'s Delegation record has been set to today.'
                    );

                    if (selectedUser.hasAdminRole) {
                        lodash.unset(selectedUser, 'studyRole');
                        lodash.unset(selectedUser, 'studyRoleId');
                        props.editStudyTeamMember(selectedUser, 'admin', null);
                        return;
                    }
                    removeUser(selectedUser);
                },
                delegation.studyId
            );
        } else {
            props.updateStudyDelegationV2(
                delegation.binderId,
                delegation,
                [],
                [],
                () => {
                    setShowModalAudit(false);
                    setAuditNote('');
                    props.stackASuccessMessage(
                        'This End Date on this user\'s Delegation record has been set to today.'
                    );

                    if (selectedUser.hasAdminRole) {
                        lodash.unset(selectedUser, 'studyRole');
                        lodash.unset(selectedUser, 'studyRoleId');
                        props.editStudyTeamMember(selectedUser, 'admin', null);
                        return;
                    }
                    removeUser(selectedUser);
                },
                delegation.studyId
            );
        }
    };

    if (!showModalAudit) {
        return null;
    }

    return (
        <StudyModal
            data-cy="StudySettingsTeamV2-StudyModal"
            isOpen={showModalAudit}
            onClose={() => {
                setShowModalAudit(false);
                setAuditNote('');
            }}
            onSave={handleOnSave}
            isDisabled={isRequiredNote && lodash.isEmpty(auditNote)}
            title={'Audit Explanation for User’s Delegation'}
            onCancelText={'Cancel'}
            onSaveText={'Confirm'}
            bodyContainer={
                <React.Fragment data-cy="StudySettingsTeamV2-Fragments">
                    <Conditional condition={isRequiredNote}>
                        <div className="description">
                            This Study User has a delegation that has been signed. Modifying data
                            after signature requires a note for the audit log. Please enter notes
                            for the audit log.
                        </div>
                    </Conditional>
                    <Conditional condition={!isRequiredNote}>
                        <div className="description">
                            This Study User has a delegation that has NOT been signed. Modifying
                            data before signature does NOT require a note for the audit log.
                            Entering notes for the audit log is optional.
                        </div>
                    </Conditional>
                    <div className="note" >
                        Audit Notes
                        <Conditional condition={isRequiredNote}>
                            <span>*Required</span>
                        </Conditional>
                    </div>
                    <textarea
                        data-cy="StudySettingsTeamV2-textarea"
                        name="auditNote"
                        rows="4"
                        value={auditNote}
                        onChange={(e) => {
                            setAuditNote(e.target.value);
                        }}
                        placeholder="Add notes to the audit record of this delegation..."
                    />
                </React.Fragment>
            }
        />
    );
};

export const RemoveStudyTeamModal = ({
    showModal,
    setShowModal,
    setShowModalAudit,
    selectedUser,
    userType,
    ...props
}) => {
    if (!showModal) {
        return null;
    }

    const handleOnSave = () => {
        if (checkDelegationConditions(
            showModal,
            setShowModal,
            setShowModalAudit,
            selectedUser,
            userType,
            props)
        ) {
            return;
        }
        props.removeUser(selectedUser);
        setShowModal(false);
    };

    return <ActionModal
        isOpen={showModal}
        onClose={() => setShowModal(false)}
        onSave={handleOnSave}
        title={`Remove ${STUDY_TEAM_CAPITAL[userType.toUpperCase()]}`}
        data-cy="StudySettingsTeamV2-ActionModal"
    >
        <ModalHelperText userType={userType} />
    </ActionModal>;

};

function checkDelegationConditions(
    showModal,
    setShowModal,
    setShowModalAudit,
    selectedUser,
    userType,
    props) {
    if (selectedUser.studyRoleId) {
        setShowModal(false);
        setShowModalAudit(true);
        return true;
    }
    return false;
}
export const ModalHelperText = ({ userType }) => {
    switch (userType) {
        case STUDY_USER_TYPE.VIEWER:
            return <div data-cy="StudySettingsTeamV2-VIEWER">
                <p>Removing this Study Viewer means they will no longer have access to this
                    study. If this Study Viewer’s documents were uploaded into Complion, we will hold
                    onto their current and any future documents.</p>
                <br />
                <br />
                <p>Are you sure you want to remove this Study Viewer?</p>
            </div>;
        case STUDY_USER_TYPE.TEAM:
            return <div data-cy="StudySettingsTeamV2-TEAM">
                <p>When you remove a Study Team Member, we will hold onto their current and any future
                    documents that are uploaded into Complion.</p>
                <br />
                <br />
                <p>Are you sure you want to remove this Study Team member?</p>
            </div>;
        case STUDY_USER_TYPE.ADMIN:
            return <div data-cy="StudySettingsTeamV2-ADMIN">
                <p>Removing this Study Admin means they will no longer have access to this
                    study. If this Study Admin’s documents were uploaded into Complion, we will hold onto
                    their current and any future documents.</p>
                <br />
                <br />
                <p>Are you sure you want to remove this Study Admin?</p>
            </div>;
        case STUDY_USER_TYPE.MONITOR:
            return <div data-cy="StudySettingsTeamV2-MONITOR"><p>Are you sure you want to remove this study monitor?</p></div>;
        default:
            return '';
    }
};


export default connect((state, props) => {
    const study = lodash.get(props, 'study', null);
    const selectedStudyTeams = getSortedStudyTeamMembers(state);
    const users = getTeamMemberSelection(state);
    const usersWithSameGroup = getUsersWithSameGroups(state);
    const staffDescriptor = lodash.get(state, 'studySettings.staffDescriptor', []);
    const studyRoles = lodash.get(state, 'studySettings.studyRoles', []);
    const isProcessingStudySettings =
        lodash.get(state, 'studySettings.processingStudySettings', false) || (!lodash.isNil(studyRoles) &&
            !lodash.isNil(staffDescriptor) &&
            !lodash.isNil(selectedStudyTeams));
    const allTeamMembers = lodash.get(state, 'studySettings.allTeamMembers', []);
    const binderUsers = lodash.get(state, 'binder.users', []);
    const doaStudyTasks = lodash.get(state, 'doaStudyTasks', []);
    const doaStudyDelegations = lodash.get(state, 'doaStudyDelegations', []);
    const isDoaEnabled = doaFeatureAccess(state);
    const activePI = getActivePI(state);

    const binderId = lodash.get(state, 'binder.id');
    const doaMode =
        lodash.get(lodash.get(state, 'me', {}), 'isInstitutionCentralized') === 'true'
            ? 'CENTRAL'
            : 'STANDARD';
    const institutionTimezone = lodash.get(lodash.get(state, 'me', {}), 'institutionTimezone', 'Z');

    const canManageStudyAdmins = manageAdminsPredicate(state);
    const canManageStudyUsers = manageStudyTeamMemberPredicateOld(state);

    return {
        activePI,
        study,
        users,
        selectedStudyTeams,
        staffDescriptor,
        studyRoles,
        isProcessingStudySettings,
        allTeamMembers,
        binderUsers,
        doaStudyTasks,
        doaStudyDelegations,
        isDoaEnabled,
        doaMode,
        binderId,
        institutionTimezone,
        canManageStudyAdmins,
        canManageStudyUsers,
        usersWithSameGroup,
    };
}, {
    getTeamMembersByInstitution,
    getStudyDescriptors,
    getStudyRoles,
    getStudyTeam,
    createTeamMember,
    modifyStudyTeamMember,
    removeStudyTeamMember,
    unloadStudySettingsTeam,
    editStudyTeamMember,
    loadStudyTasksV2,
    loadStudyDelegationsV2,
    push,
    stackASuccessMessage,
    updateStudyDelegationV2
})(StudyTeamV2);
